<template>
    <v-card>
        <v-card-title class="text-h5 grey lighten-2">
            {{termo.titulo}}
        </v-card-title>

        <v-card-text class="mt-3" v-html="termo.texto">
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <v-spacer></v-spacer>
         
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    data() {
        return {
        
            termo: { titulo: "", texto: ""}
        }
    },
    async mounted() { 
        const { data } = await this.$http.get(`items/termos/?filter[slug][_eq]=politica-de-privacidade&filter[status][_eq]=published`);
        this.termo = data.data[0]
    }
}
</script>